module.exports = __webpack_public_path__ + "img/corset.da547041.jpg";